export default __webpack_public_path__ + "static/media/ad_0.05e93b20.mp3";